import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'
/**
 * rem转px
 * @param {Number | String} rem 待转换的rem值，如1.2或'1.2rem'
 * @param {Boolean} isNeedPxSuffix 要px后缀吗，默认不需要
 * @returns 转换后的像素值
 */
 export function remToPx (rem, isNeedPxSuffix = false) {
  rem = String(rem).replace(/rem/g, '')

  let val = rem * Number(document.documentElement.style.fontSize.replace(/px/g, ''))

  return isNeedPxSuffix ? `${val}px` : val
}
/**
 * 将数字转换为中文的金额
 * @method cnMoneyFormat
 * @param {Number} money 数字
 */
 export function cnMoneyFormat(money) {
  var cnMoney = "零元整";
  var strOutput = "";
  var strUnit = '仟佰拾亿仟佰拾万仟佰拾元角分';
  money += "00";
  var intPos = money.indexOf('.');
  if (intPos >= 0) {
     money = money.substring(0, intPos) + money.substr(intPos + 1, 2);
  }
  strUnit = strUnit.substr(strUnit.length - money.length);
  for (var i = 0; i < money.length; i++) {
     strOutput += '零壹贰叁肆伍陆柒捌玖'.substr(money.substr(i, 1), 1) + strUnit.substr(i, 1);
  }
  cnMoney = strOutput.replace(/零角零分$/, '整').replace(/零[仟佰拾]/g, '零').replace(/零{2,}/g, '零').replace(/零([亿|万])/g, '$1').replace(/零+元/, '元').replace(/亿零{0,3}万/, '亿').replace(/^元/, "零元");
  return cnMoney;
}
/**
 * dom导出pdf
 * @param {String} dom // 元素
 * @param {Sting} pdfTitle // pdf标题
 */
 export function htmlToPdf (dom, pdfTitle, callback) {
  let printDom = document.querySelector(dom)
  const A4_WIDTH = 592.28
  const A4_HEIGHT = 841.89
  // 根据A4的宽高计算DOM页面一页应该对应的高度
  let pageHeight = printDom.offsetWidth / A4_WIDTH * A4_HEIGHT
  // 将所有不允许被截断的元素进行处理
  let wholeNodes = document.querySelectorAll('.whole-node')
  for (let i = 0; i < wholeNodes.length; i++) {
    const topPageNum = Math.ceil((wholeNodes[i].offsetTop) / pageHeight)
    const bottomPageNum = Math.ceil((wholeNodes[i].offsetTop + wholeNodes[i].offsetHeight) / pageHeight)
    if (topPageNum !== bottomPageNum) {
      // 说明该dom会被截断
      // 2、插入空白块使被截断元素下移
      let divParent = wholeNodes[i].parentNode
      let newBlock = document.createElement('div')
      newBlock.className = 'emptyDiv'
      newBlock.style.background = '#fff'
      let _H = topPageNum * pageHeight - wholeNodes[i].offsetTop
      // 填充元素高度 需要根据业务调整
      newBlock.style.height = _H + wholeNodes[i].offsetHeight + 150 + 'px'
      divParent.insertBefore(newBlock, wholeNodes[i])
    }
  }
  let PDF = new JsPDF('', 'pt', 'a4')
  html2Canvas(document.querySelector(dom), {
    allowTaint: true,
    useCORS: true
  }).then(function (canvas) {
    // dom 已经转换为canvas 对象，可以将插入的空白块删除了
    let emptyDivs = document.querySelectorAll('.emptyDiv')
    for (let i = 0; i < emptyDivs.length; i++) {
      emptyDivs[i].parentNode.removeChild(emptyDivs[i])
    }
    let contentWidth = canvas.width
    let contentHeight = canvas.height
    let pageHeight = contentWidth / 592.28 * 841.89
    let leftHeight = contentHeight
    let position = 0
    let imgWidth = 595.28
    let imgHeight = 592.28 / contentWidth * contentHeight
    let pageData = canvas.toDataURL('image/jpeg', 1)
    if (leftHeight < pageHeight) {
      PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
    } else {
      while (leftHeight > 0) {
        PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
        leftHeight -= pageHeight
        position -= 841.89
        if (leftHeight > 0) {
          PDF.addPage()
        }
      }
    }
    PDF.save(pdfTitle + ".pdf");
    callback && callback()
  }
  ).catch(() => {
    callback && callback()
  })
}